<template>
  <antd-icon v-if="icon" class="icon" :type="icon" v-bind="$attrs"></antd-icon>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { createFromIconfontCN } from "@ant-design/icons-vue";
const iconfontScriptUrl = "//at.alicdn.com/t/c/font_3700948_0jq0qoszien6.js";
const AntdIcon = createFromIconfontCN({
  scriptUrl: iconfontScriptUrl
});

export default defineComponent({
  name: "IconFont",
  props: ["icon"],
  components: {
    AntdIcon
  }
});
</script>
<style lang="less" scoped>
.anticon {
  font-size: 16px;
}
</style>
